export const supportsDynamicViewportHeight = () =>
  typeof CSS !== "undefined" &&
  typeof CSS.supports === "function" &&
  CSS.supports("height", "100dvh");

export const getDynamicViewportHeight = () =>
  supportsDynamicViewportHeight() ? "100dvh" : "100vh";

export const getDynamicViewportHeightCalc = (offsetPx: number) =>
  `calc(${getDynamicViewportHeight()} - ${offsetPx}px)`;
